/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ResumePrescriptionDialog.vue?vue&type=template&id=199c8a30"
import script from "./ResumePrescriptionDialog.vue?vue&type=script&lang=js"
export * from "./ResumePrescriptionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('199c8a30')) {
      api.createRecord('199c8a30', component.options)
    } else {
      api.reload('199c8a30', component.options)
    }
    module.hot.accept("./ResumePrescriptionDialog.vue?vue&type=template&id=199c8a30", function () {
      api.rerender('199c8a30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/ResumePrescriptionDialog.vue"
export default component.exports